// src/components/Calendar/modals/ServiceModal.tsx
import React, {Fragment, useEffect, useMemo} from "react";
import {Dialog, Transition} from "@headlessui/react";
import {useCheckout} from "../hooks/useCheckout";

interface BusinessService {
    id: number;
    title: string;
    description?: string;
    duration: number;
    priceCents: number;
}

interface Employee {
    id: number;
    name: string;
}

interface Service {
    id: number;
    title: string;
    description?: string;
    duration: number;
    priceCents: number;
    employee: Employee;
    businessService: BusinessService;
    status: string;
}

interface SelectedEvent {
    id?: number;
    services?: Service[];
}

interface ServiceModalProps {
    services: any;
    isOpen: boolean;
    onClose: () => void;
    selectedEvent: SelectedEvent;
    selectedServices: any;


}

export const ServiceModal: React.FC<any> = ({
                                                isOpen,
                                                onClose,
                                                services,
                                                selectedEvent,
                                                selectedServices,
                                                onHandleAddService
                                            }) => {
    // const { addService } = useCheckout();

    // 🧠 Determine which services are already selected
    const selectedServiceIds = useMemo(() => {
        return (selectedEvent?.services ?? []).map((s: any) => s.id);
    }, [selectedEvent.services]);

    const handleAddService = (service: Service) => {
        if (selectedServiceIds.includes(service.id)) return;
        // addService(service);
        onHandleAddService(service)
        onClose();
    };


    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                {/* Background Overlay */}
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/30"/>
                </Transition.Child>

                {/* Modal Panel */}
                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title className="text-lg font-semibold mb-4">
                                    Add Service
                                </Dialog.Title>

                                {/* Dynamic Services List */}
                                <div className="space-y-3 max-h-80 overflow-y-auto">
                                    {services.length === 0 ? (
                                        <p className="text-gray-500 text-sm text-center py-4">
                                            No services available
                                        </p>
                                    ) : (
                                        services.filter((s:any)=>s?.status==='active').map((service: any) => {
                                            const isSelected = selectedServiceIds.includes(service.id);
                                            return (
                                                <button
                                                    key={service.id}
                                                    disabled={isSelected}
                                                    onClick={() => handleAddService(service)}
                                                    className={`w-full flex justify-between items-center px-4 py-3 border rounded-lg transition
                            ${
                                                        isSelected
                                                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                            : "hover:bg-gray-50"
                                                    }`}
                                                >
                                                    <div className="text-left">
                                                        <p className="font-medium">{service.title}</p>
                                                        <p className="text-sm text-gray-500">
                                                            {service.description}
                                                        </p>
                                                    </div>
                                                    <div className="text-sm font-semibold text-gray-600">
                                                        ${(service.priceCents / 100).toFixed(2)}
                                                    </div>
                                                </button>
                                            );
                                        })
                                    )}
                                </div>

                                <div className="mt-6 flex justify-end">
                                    <button
                                        onClick={onClose}
                                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                                    >
                                        Close
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};
